import React from 'react';
import PropTypes from 'prop-types';

// MUI components
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

// Styled
import {StyledTableCell, StyledTableRow} from 'components/styled';

// Custom Components
import Disclosure from 'components/Disclosure';

import {computeRestrictionText, computeResourceRestrictionByPatientText} from 'utils';
import SimilarResourceSearch from './SimilarResourceSearch';

const BasicTable = ({tableData, fieldNames, globalRestriction, resourceId}) => {
  return (
    <Table style={{alignItems: 'center'}}>
      <TableHead>
        <TableRow>
          {fieldNames.map((fieldName, index) => (
            <StyledTableCell
              style={fieldName.key === 'isRestricted' ? {paddingLeft: 36} : null}
              key={`${fieldName}-${index}-${fieldName.value}`}
            >
              {fieldName.value}
            </StyledTableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {tableData &&
          tableData.map((row, index) => (
            <StyledTableRow key={`row-data-${index}-${row}`}>
              {fieldNames &&
                fieldNames.map((fieldName, index) => (
                  <TableCell component="th" scope="row" key={`${fieldName}-${index}`}>
                    {fieldName.key === 'isRestricted' ? (
                      <Disclosure
                        isRestricted={
                          globalRestriction.isRestricted ? globalRestriction.isRestricted : row[fieldName.key]
                        }
                      ></Disclosure>
                    ) : fieldName.key === 'restrictions' ? (
                      globalRestriction.isRestricted ? (
                        globalRestriction.restrictionCode.map((restrictionCode) => (
                          <div key={restrictionCode}>{computeResourceRestrictionByPatientText(restrictionCode)}</div>
                        ))
                      ) : (
                        row[fieldName.key] &&
                        row[fieldName.key].map((restriction, index) =>
                          restriction.isActive ? (
                            <div key={`${restriction.code}-${index}`}>{computeRestrictionText(restriction)}</div>
                          ) : (
                            <div key={`${restriction.code}-${index}`}></div>
                          )
                        )
                      )
                    ) : fieldName.key === 'value' && resourceId ? (
                      <SimilarResourceSearch system={row['system'] || '-'} value={row[fieldName.key] || '-'} resourceId={resourceId} />
                    ) : (
                      <div>{row[fieldName.key] || '-'}</div>
                    )}
                  </TableCell>
                ))}
            </StyledTableRow>
          ))}
      </TableBody>
    </Table>
  );
};

BasicTable.propTypes = {
  tableData: PropTypes.array,
  fieldNames: PropTypes.array,
  globalRestriction: PropTypes.object,
  resourceId: PropTypes.string
};

export default BasicTable;
